import { useEffect, useState } from "react";

const secondsUntil = (time) => (time ? Math.max(0, Math.ceil((time - Date.now()) / 1000)) : 0);

// Whole seconds left until targetTime (a ms timestamp), updated every second
export default function useCountdown(targetTime) {
  const [secondsLeft, setSecondsLeft] = useState(() => secondsUntil(targetTime));

  useEffect(() => {
    setSecondsLeft(secondsUntil(targetTime));
    const timer = setInterval(() => {
      const left = secondsUntil(targetTime);
      setSecondsLeft(left);
      if (left === 0) clearInterval(timer);
    }, 1000);

    return () => clearInterval(timer);
  }, [targetTime]);

  return secondsLeft;
}
